import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sum } from 'lodash'

import {
  StatisticWrapper,
  Title,
  InfoMessage,
  ValueWrapper,
  UnitsSpan,
  CenterWrapper,
} from './statistic.styles'
import { StatisticProps } from './statistic.types'
import Tooltip from '../tooltip/tooltip'

const Statistic: FC<StatisticProps> = (props: StatisticProps): React.ReactElement => {
  const { data, title, type, units, infoMessage, isLoading, isMobile } = props
  let value
  let formatedUnits = units
  if (type === 'sumProdReal' && Array.isArray(data)) {
    value = Math.round(sum(data.map((element) => element[1])))
    if (value > 999999) {
      value = Math.round(value / 1000)
      formatedUnits = 'MWh'
    }
  }
  if (type === 'CA') value = data
  if ((Array.isArray(data) && data.length === 0) || data === null) value = undefined

  return (
    <StatisticWrapper>
      <Title>
        <span>{title}</span>
        {infoMessage && !isMobile && (
          <InfoMessage>
            <Tooltip text={infoMessage}>
              <FontAwesomeIcon icon="info-circle" size="1x" />
            </Tooltip>
          </InfoMessage>
        )}
      </Title>
      {isLoading && (
        <CenterWrapper>
          <FontAwesomeIcon icon="spinner" spin size="lg" />
        </CenterWrapper>
      )}
      {!isLoading && (
        <ValueWrapper>
          {typeof value === 'undefined' && <FontAwesomeIcon icon="exclamation-triangle" />}
          {value && (
            <>
              {`${new Intl.NumberFormat('fr-FR').format(Number(value))}`}
              <UnitsSpan> {formatedUnits}</UnitsSpan>
            </>
          )}
        </ValueWrapper>
      )}
    </StatisticWrapper>
  )
}

export default Statistic
